import { FC, SVGProps } from 'react'

const Deal: FC<SVGProps<SVGSVGElement>> = svgProps => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid="deal-icon"
    {...svgProps}
  >
    <path
      d="M14.4275 16H5.8325C5.8325 16 5.8325 13.9901 6.41432 13.6463C6.99613 13.3025 8.08043 13.5669 8.08043 13.5669V12.9058C8.08043 12.9058 7.5249 12.7471 7.5249 12.3504C7.5249 11.9537 7.92175 11.7686 7.92175 11.7686H10.6986C10.6986 11.7686 10.725 11.0281 8.87381 7.21986C7.02258 3.41161 3.37301 1.66616 3.37301 1.66616C3.37301 1.66616 5.33002 3.25293 6.78456 5.10417C8.2391 6.9554 9.45563 10.3934 9.45563 10.3934C9.45563 10.3934 6.62544 10.0231 5.67338 7.85452C4.72132 5.68593 2.44001 2.30082 2.18248 1.79834C1.92496 1.29586 1.57422 0 1.57422 0C1.57422 0 9.13812 3.57024 10.5927 6.84957C12.0472 10.1289 10.8042 9.83799 10.8042 9.83799L11.4655 11.7686H11.9945C11.9945 11.7686 12.6819 11.9008 12.7084 12.3504C12.7348 12.8 12.1531 12.7736 12.1531 12.7736V13.5669C12.1531 13.5669 13.634 13.4347 13.9778 13.6463C14.3216 13.8579 14.4275 16 14.4275 16Z"
      fill="currentColor"
    />
  </svg>
)

export default Deal
